import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AccessControlType } from '../../foundation/models/enums/access-control-type.enum';

@Injectable()
/**
 * Requires the currently logged in user to have allow view omni and advanced search
*/
export class OmniSearchAuthGuard implements CanActivate {

    private accessControlType: AccessControlType = new AccessControlType();

    constructor(private _auth: AuthService,
        private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // check auth service for allow view omni search bar
        if (this._auth.hasApplicationAccess && !this._auth.hasACSTransactionClaimEx(this._auth.acsTransactionClaim, this.accessControlType.AllowViewOmniSearchBar.value)) {
            this.router.navigate(['/']);
            return false;
        } else {
            return true;
        }
    }
}
